import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import { Link } from "@novaescola/eva-react-v2/lib/Link";

import { useInView } from "../../hooks/useInView";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

const CarouselRelatedContent = ({ contents }) => {
  const carouselRelatedContentRef = useRef(null);

  const isInView = useInView(carouselRelatedContentRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - Nova página de conteúdo - Carrossel Relacionadas - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - Nova página de conteúdo - Carrossel Relacionadas - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <>
      <Typography
        variant="title"
        size={4}
        asChild
        className="eva-margin-top-4 eva-text-center"
      >
        <h2 ref={carouselRelatedContentRef}>Conteúdos Relacionados</h2>
      </Typography>
      <div className="eva-margin-top-6">
        <Swiper
          breakpoints={{
            320: {
              slidesPerView: 1.2,
            },
            480: {
              slidesPerView: 3,
            },
            640: {
              slidesPerView: 4,
            },
          }}
          slidesPerView={4}
          spaceBetween={15}
          navigation={window.innerWidth <= 640 || contents.length > 4 }
          modules={[Navigation]}
          className="eva-react-carrossel eva-margin-bottom-4"
          id="carrossel-relacionadas"
        >
          {contents.map((content, index) => (
            <SwiperSlide
              key={`item-relaciondas-${content.id}`}
              id={`card-relacionadas-${content.id}`}
            >
              <div className="eva-card eva-bg-branco">
                <Link
                  href={content.url}
                  noUnderline
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "cta_click",
                      category: "link",
                      label: `SITE: Click - Nova página de conteúdo - destaque relacionadas ${index + 1} - carrossel`
                    })
                  }}
                >
                  <div className="eva-card-img">
                    <div className="eva-card-bg" />
                    <img
                      src={content.featuredImage}
                      className="card-img"
                      alt="Sem texto alternativo"
                      onError={(event) => { event.target.src = "https://nova-escola-producao.s3.amazonaws.com/e75cd25f-6b5d-4638-87e7-b5bf5d915aa6.webp" }}
                    />
                  </div>
                  <div className="eva-card-info">
                    <Typography
                      variant="body"
                      size={2}
                      className="eva-card-title eva-text-bold"
                    >
                      {content.title}
                    </Typography>
                  </div>
                </Link>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default CarouselRelatedContent;
